import * as actionTypes from "../actions/actionTypes";

const initialState = {payments: []};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.GET_PAYMENTS:
      return {
        ...state,
        payments: [action.payload.payments],
      };

    default:
      return state;
  }
};
export default paymentReducer;
